import { IOrder } from "models/api/IOrder";

export const getOrderSum = (order: IOrder) => {
    return Math.round(order.rows.reduce((prev, current) => prev + current.price * current.quantity, 0) * 100) / 100;
};
